import axios from 'axios';
import config from '../config';

const API = axios.create({
  baseURL: config.recomotor.crmApiUrl,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': config.app.originUrl
  },
});

export default API;